import React from "react";
import Header from "../parts/header";
import Leftbar from "../parts/leftbarCoaching";

function Page({ children }) {
  return (
    <div id="athlete-wrapper">
      <label htmlFor="mobile-nav-toggle" />
      <Header athletePortalEnabled />
      <Leftbar />
      {children}
    </div>
  );
}

export default Page;
